import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

export default function GuestCheckoutModal({ open, onClose, onSubmit, busy, nextPath }) {
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  if (!open) return null;

  const submit = () => {
    if (!name.trim() || !email.trim()) return;
    onSubmit({ name: name.trim(), email: email.trim() });
  };

  return (
    <div
      data-testid="guest-checkout-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md bg-[#F2E9D8] border-2 border-[#121212] p-8 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button data-testid="guest-modal-close" onClick={onClose} className="absolute top-4 right-4 p-1 hover:bg-[#121212]/10">
          <X size={20} />
        </button>
        <p className="text-xs tracking-[0.3em] uppercase font-bold">Almost there</p>
        <h2 className="font-serif font-black text-3xl text-[#121212] mt-2">Your details</h2>
        <p className="text-sm text-[#121212]/70 mt-2">
          We'll send your confirmation here. No account needed.
        </p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="text-xs tracking-[0.2em] uppercase font-bold block mb-2">Full name</label>
            <input
              data-testid="guest-name-input"
              value={name} onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 border-2 border-[#121212] bg-white focus:outline-none"
            />
          </div>
          <div>
            <label className="text-xs tracking-[0.2em] uppercase font-bold block mb-2">Email</label>
            <input
              data-testid="guest-email-input"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border-2 border-[#121212] bg-white focus:outline-none"
            />
          </div>
        </div>

        <button
          data-testid="guest-continue-btn"
          onClick={submit} disabled={busy || !name.trim() || !email.trim()}
          className="mt-6 w-full px-8 py-4 bg-[#121212] text-[#F2E9D8] hover:bg-black disabled:opacity-40 text-xs tracking-[0.25em] uppercase font-bold transition-all"
        >
          {busy ? "Loading…" : "Continue to payment"}
        </button>

        <button
          data-testid="guest-signin-link"
          onClick={() => nav(`/login?next=${encodeURIComponent(nextPath || "/")}`)}
          className="mt-4 w-full text-center text-xs tracking-[0.15em] uppercase font-bold text-[#121212] hover:underline"
        >
          Already have an account? Sign in
        </button>
      </div>
    </div>
  );
}
